define("shared/types/generic-media", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
});